// mobile
const deviceSizes = {
  mobile: "375px",
  tablet: "768px",
  laptop: "1024px",
};
export const device = {
  mobile: `only screen and (max-width: ${deviceSizes.mobile})`,
  tablet: `only screen and (max-width: ${deviceSizes.tablet})`,
  laptop: `only screen and (max-width: ${deviceSizes.laptop})`,
};

// color
export const black = "#1D1D1B";
export const bg = "";
export const error = "#ED4337";
// font
export const caption1 = `
    font-family : suitRegular;
    font-size : 12px;
    line-height : auto;
    font-weight : 500;
`;
export const head1 = `
    font-family : suitExtraBold;
    font-size : 20px;
    line-height : 30px;
    font-weight : 500;
`;
export const head2 = `
    font-family : suitExtraBold;
    font-size : 18px;
    line-height : 30px;
    font-weight : 500;
`;
export const head3 = `
    font-family : suitBold;
    font-size : 12px;
    line-height : auto;
    font-weight : 500;
`;
export const head4 = `
    font-family : suitBold;
    font-size : 14px;
    line-height : auto;
    font-weight : 500;
`;
export const body1 = `
    font-family : suitMedium;
    font-size : 14px;
    line-height : auto;
    font-weight : 500;
`;
